/* SlideFoot — Reseñas: botones, puntos, teclado y avance automático opcional */
(function () {
  if (window.__sfrIniciado) return;
  window.__sfrIniciado = true;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');

  function iniciar(raiz) {
    if (raiz.__sfr) return;
    raiz.__sfr = true;
    var pista = raiz.querySelector('[data-sfr-pista]');
    var prev = raiz.querySelector('[data-sfr-prev]');
    var next = raiz.querySelector('[data-sfr-next]');
    var puntos = raiz.querySelector('[data-sfr-puntos]');
    if (!pista) return;
    var tarjetas = function () { return Array.prototype.slice.call(pista.children); };

    function paso() {
      var t = tarjetas();
      if (t.length < 2) return pista.clientWidth;
      return t[1].offsetLeft - t[0].offsetLeft;
    }
    function porVista() { return Math.max(1, Math.round(pista.clientWidth / paso())); }
    function paginas() { return Math.max(1, Math.ceil((tarjetas().length - porVista()) / porVista()) + 1); }
    function mover(dir) {
      var max = pista.scrollWidth - pista.clientWidth;
      var destino = Math.min(max, Math.max(0, pista.scrollLeft + dir * paso() * porVista()));
      pista.scrollTo({ left: destino, behavior: reducido.matches ? 'auto' : 'smooth' });
    }
    function pintarPuntos() {
      if (!puntos) return;
      var n = paginas();
      if (puntos.children.length !== n) {
        puntos.innerHTML = '';
        for (var i = 0; i < n; i++) { var p = document.createElement('span'); p.className = 'sfr__punto'; puntos.appendChild(p); }
      }
      var max = pista.scrollWidth - pista.clientWidth;
      var actual = max <= 0 ? 0 : Math.round((pista.scrollLeft / max) * (n - 1));
      Array.prototype.forEach.call(puntos.children, function (p, i) { p.classList.toggle('sfr__punto--activo', i === actual); });
    }
    function estado() {
      var max = pista.scrollWidth - pista.clientWidth - 2;
      if (prev) prev.disabled = pista.scrollLeft <= 2;
      if (next) next.disabled = pista.scrollLeft >= max;
      pintarPuntos();
    }

    if (prev) prev.addEventListener('click', function () { parar(); mover(-1); });
    if (next) next.addEventListener('click', function () { parar(); mover(1); });
    pista.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); parar(); mover(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); parar(); mover(-1); }
    });
    var esperando;
    pista.addEventListener('scroll', function () { cancelAnimationFrame(esperando); esperando = requestAnimationFrame(estado); }, { passive: true });
    window.addEventListener('resize', estado);

    /* Avance automático: apagado por defecto; se detiene con cualquier interacción */
    var cada = parseInt(raiz.getAttribute('data-autoplay'), 10) || 0;
    var reloj = null, tocado = false;
    function pausar() { if (reloj) { clearInterval(reloj); reloj = null; } }
    function parar() { tocado = true; pausar(); }
    function arrancar() {
      if (!cada || reloj || tocado || reducido.matches) return;
      reloj = setInterval(function () {
        var max = pista.scrollWidth - pista.clientWidth - 2;
        if (pista.scrollLeft >= max) pista.scrollTo({ left: 0, behavior: 'smooth' }); else mover(1);
      }, cada * 1000);
    }
    raiz.addEventListener('mouseenter', pausar);
    ['focusin', 'touchstart', 'pointerdown'].forEach(function (ev) { raiz.addEventListener(ev, parar, { passive: true }); });
    raiz.addEventListener('mouseleave', arrancar);
    document.addEventListener('visibilitychange', function () { if (document.hidden) pausar(); else arrancar(); });

    estado();
    arrancar();
  }

  /* En la página de producto: en computadora, mover las reseñas debajo de las fotos */
  var marca = null;
  var ancho = window.matchMedia('(min-width: 761px)');
  function colocar() {
    var slot = document.querySelector('[data-sf-resenas-slot]');
    if (!slot) return;
    var sfr = document.querySelector('.shopify-section [data-sfr]');
    var sec = sfr && sfr.closest('.shopify-section');
    if (!sec || sec.contains(slot)) return;
    if (ancho.matches) {
      if (sec.parentNode === slot) return;
      if (!marca) { marca = document.createComment('sf-resenas'); sec.parentNode.insertBefore(marca, sec); }
      slot.appendChild(sec);
    } else if (marca && sec.parentNode === slot) {
      marca.parentNode.insertBefore(sec, marca);
    }
    window.dispatchEvent(new Event('resize'));
  }
  if (ancho.addEventListener) ancho.addEventListener('change', colocar);

  function todos() { colocar(); document.querySelectorAll('[data-sfr]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  /* Editor de Shopify: volver a iniciar al editar la sección */
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-sfr]'); if (r) { marca = null; colocar(); iniciar(r); } });
})();
